import styled from 'styled-components'
import { ModalHeaderSkeleton } from '../ModalComponents/ModalHeader/Skeleton'
import { Skeleton } from '~/components/shared'

export const Container = styled.div`
  flex: 1;
  margin: 20px;
  position: relative;
  height: calc(100vh - 110px);
  display: flex;
  flex-direction: column;
`

export const ReturnArrowButton = styled.button`
  position: absolute;
  top: 0;
  left: 0px;
  border: none;
  background: none;
  transform: translateY(-49px);
  font-size: 0;

  cursor: pointer;

  svg {
    color: ${props => props.theme.colors.color9ba8ba};
  }
  &:hover svg {
    color: ${props => props.theme.colors.color6a7380};
  }
`

export const BreadCrumbsContainer = styled.div`
  position: relative;
  width: 100%;
  margin-bottom: 10px;
`

export const BackButtonContainer = styled.div`
  display: flex;
  position: relative;
  width: 100%;
`

export const HeaderContainer = styled.div``

export const ContentContainer = styled.div`
  position: relative;
  flex-flow: column;
  height: calc(100% - 110px);

  padding-right: 4px;
`

export const Message = styled.p`
  font-size: 0.8rem;
  color: ${props => props.theme.colors.color545e6c};
  text-align: center;
  padding-top: 50%;
`

export const RelatedMessage = styled.p`
  margin-top: 18px;
  line-height: 16px;
  font-weight: normal;
  font-size: 0.8rem;
  color: ${props => props.theme.colors.color545e6c};
`

export const RelatedProcedureSkeleton = styled(Skeleton).attrs(props => ({
  baseColor: props.theme.colors.colorf2f7ff
}))`
  margin-top: 7px;
  height: 40px;
  border-radius: ${({ theme }) => theme.zds.border.radius100};
`

export const RelatedContentContainer = styled.div`
  display: flex;
  position: relative;
  height: 100%;
  overflow: auto;
`

export const CustomSkeleton = styled(ModalHeaderSkeleton).attrs(props => ({
  ...props
}))`
  margin-bottom: 16px;
`
